import { api } from './client'

const API_BASE = import.meta.env.VITE_API_URL || ''

export interface User {
  id: string
  email: string
  name: string
  role: 'supervisor' | 'member'
  firm_id: string
}

export interface RequestOtpRequest {
  email: string
}

export interface RequestOtpResponse {
  message: string
}

export interface VerifyOtpRequest {
  email: string
  otp: string
}

export interface VerifyOtpResponse {
  access_token: string
  refresh_token: string
  token_type: string
  expires_in: number
  user: User
}

export interface RefreshResponse {
  access_token: string
  refresh_token: string
  token_type: string
  expires_in: number
}

export const authApi = {
  /**
   * Request OTP to be sent to email
   */
  requestOtp: (data: RequestOtpRequest): Promise<RequestOtpResponse> => {
    return api.post('/api/v1/auth/request-otp', data)
  },

  /**
   * Verify OTP and get JWT token
   */
  verifyOtp: (data: VerifyOtpRequest): Promise<VerifyOtpResponse> => {
    return api.post('/api/v1/auth/verify-otp', data)
  },

  /**
   * Get current user info
   */
  getMe: (): Promise<User> => {
    return api.get('/api/v1/auth/me')
  },

  /**
   * Refresh access token using a refresh token.
   * Uses raw fetch() to avoid the api client's 401 interception loop.
   */
  refreshToken: async (refreshToken: string): Promise<RefreshResponse> => {
    const response = await fetch(`${API_BASE}/api/v1/auth/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh_token: refreshToken }),
    })

    if (!response.ok) {
      throw new Error(`Refresh failed: ${response.status}`)
    }

    return response.json()
  },

  /**
   * Server-side logout — best-effort, errors are silently caught.
   */
  logoutServer: async (accessToken: string, refreshToken: string): Promise<void> => {
    try {
      await fetch(`${API_BASE}/api/v1/auth/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ refresh_token: refreshToken }),
      })
    } catch {
      // Best-effort — ignore errors
    }
  },
}
